import { Backdrop, CircularProgress } from "@mui/material"

const Loading = ({loading}: {loading: boolean})=>{
    return (
        <Backdrop
            open={loading}
            sx={{ 
                left: 0,
                top: 0,
                backdropFilter: 'blur(4px)', 
                position: 'fixed', 
                zIndex: 1, 
                color: '#cfcfcf', 
                backgroundColor: 'rgba(255,255,255,0.5)', 
                paddingLeft: "257px",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}
export default Loading